<template>
  <div>
    <!--面包屑导航区域-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>门店管理</el-breadcrumb-item>
      <el-breadcrumb-item>美团授权管理</el-breadcrumb-item>
    </el-breadcrumb>
    <br>
    <el-card>
      <!--搜索区域-->
      <el-row :gutter="20">
        <el-col :span="8">
          <el-select v-model="queryStoreId" filterable clearable placeholder="请选择门店筛选" @change="getList">
            <el-option v-for="opt in storeList" :key="opt.id" :label="opt.storename" :value="opt.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
        </el-col>
      </el-row>
      <br>
      <!--列表区域-->
      <el-table v-loading="loading" :data="list" style="width: 100%" stripe size="medium" height="700">
        <el-table-column label="序号" type="index" width="70"></el-table-column>
        <el-table-column label="门店ID" prop="storeid" width="100"></el-table-column>
        <el-table-column label="门店名称" prop="storename" show-overflow-tooltip></el-table-column>
        <el-table-column label="美团门店ID(op_code)" prop="opCode" width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.opCode || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="删除标记" prop="delFlag" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.delFlag === '1' ? 'danger' : 'success'" size="small">
              {{ scope.row.delFlag === '1' ? '已删除' : '正常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="美团显示开关" width="140" align="center">
          <template slot-scope="scope">
            <el-tooltip
              :content="(scope.row.authorizationFlag === '1') ? '已关闭（小程序不显示美团）' : '已开启（小程序显示美团）'"
              placement="top">
              <el-switch
                :value="scope.row.authorizationFlag !== '1'"
                active-color="#67c23a"
                inactive-color="#ff4949"
                active-text="开"
                inactive-text="关"
                @change="toggleAuth(scope.row)">
              </el-switch>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" prop="updateTime" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.updateTime ? formatTime(scope.row.updateTime) : '-' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'MeituanAuth',
  data() {
    return {
      loading: false,
      list: [],
      storeList: [],
      queryStoreId: null
    }
  },
  created() {
    this.getAllStoreList()
    this.getList()
  },
  methods: {
    async getAllStoreList() {
      try {
        const { data: res } = await this.$http.get('store/')
        if (res.data) {
          this.storeList = res.data
        }
      } catch (e) {
        console.error('获取门店列表失败', e)
      }
    },
    async getList() {
      this.loading = true
      try {
        let url = 'meituan/auth/list'
        if (this.queryStoreId) {
          url += '?storeid=' + this.queryStoreId
        }
        const { data: res } = await this.$http.get(url)
        if (res.status === 0) {
          this.list = res.data || []
        } else {
          this.$message.error(res.msg || '查询失败')
        }
      } catch (e) {
        this.$message.error('请求失败')
        console.error(e)
      }
      this.loading = false
    },
    async toggleAuth(row) {
      // 当前是开启状态(flag!=1) → 要关闭(flag=1)；当前是关闭(flag=1) → 要开启(flag=0)
      const newFlag = (row.authorizationFlag === '1') ? '0' : '1'
      const actionText = newFlag === '1' ? '关闭' : '开启'
      const storeName = row.storename || ('门店ID:' + row.storeid)

      try {
        await this.$confirm(
          `确定要${actionText}【${storeName}】的美团显示吗？`,
          '提示',
          { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
        )
      } catch (e) {
        return // 取消操作
      }

      try {
        const { data: res } = await this.$http.post(
          'meituan/auth/toggle',
          null,
          { params: { id: row.id, authorizationFlag: newFlag } }
        )
        if (res.status === 0) {
          this.$message.success(`${actionText}成功`)
          this.getList()
        } else {
          this.$message.error(res.msg || '操作失败')
        }
      } catch (e) {
        this.$message.error('请求失败')
        console.error(e)
      }
    },
    formatTime(val) {
      if (!val) return '-'
      const d = new Date(val)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    }
  }
}
</script>

<style scoped>
.el-breadcrumb {
  margin-bottom: 10px;
}
</style>
